import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcClockH18(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    fill: "none",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.1 9A6.1 6.1 0 1 0 2.9 9a6.1 6.1 0 0 0 12.2 0m-6.75-.31V5.25a.65.65 0 0 1 1.3 0v3.44a.1.1 0 0 0 .03.07l2.03 2.03a.651.651 0 0 1-.92.92L8.76 9.68a1.4 1.4 0 0 1-.41-.99M16.4 9A7.4 7.4 0 1 1 1.6 9 7.4 7.4 0 0 1 16.4 9"
  }));
}
var IcClockH18 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcClockH18));

export { IcClockH18 as I };
